import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Menu, CalendarDays, LogOut } from 'lucide-react'
import { LOGO_WHITE } from '@/assets/brand'
import { GlobalSearch } from './GlobalSearch'
import { QuickAdd } from './QuickAdd'
import { NotificationsBell } from './NotificationsBell'
import { DataFreshnessChip } from './DataFreshnessChip'
import { useCurrentUser, useSignOut } from '@/auth/useCurrentUser'

export function TopBar({ onToggleNav }: { onToggleNav: () => void }) {
  const navigate = useNavigate()
  const user = useCurrentUser()
  const signOut = useSignOut()
  const [menuOpen, setMenuOpen] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!menuOpen) return
    const close = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) setMenuOpen(false)
    }
    document.addEventListener('mousedown', close)
    return () => document.removeEventListener('mousedown', close)
  }, [menuOpen])

  return (
    <header className="topbar">
      <button className="topbar-hamburger" onClick={onToggleNav} aria-label="Menu">
        <Menu size={20} />
      </button>

      <div className="topbar-brand" onClick={() => navigate('/')} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); navigate('/') } }} role="button" tabIndex={0}>
        <img src={LOGO_WHITE} alt="Westport Properties" className="topbar-logo" />
        <span className="topbar-divider" />
        <span className="topbar-appname">CRM</span>
      </div>

      <GlobalSearch />

      <div className="topbar-actions">
        <DataFreshnessChip />
        <QuickAdd />
        <button className="topbar-icon" aria-label="Calendar" onClick={() => navigate('/calendar')}>
          <CalendarDays size={18} />
        </button>
        <NotificationsBell />
        <div className="topbar-profile-wrap" ref={menuRef}>
          <button
            className="topbar-profile"
            title={`${user.displayName} — ${user.email}`}
            onClick={() => setMenuOpen((o) => !o)}
            aria-haspopup="menu"
            aria-expanded={menuOpen}
          >
            {user.photoUrl
              ? <img src={user.photoUrl} alt="" className="topbar-avatar topbar-avatar--photo" />
              : <span className="topbar-avatar">{user.initials}</span>}
            <span className="topbar-username">{user.shortName}</span>
          </button>
          {menuOpen && (
            <div className="topbar-menu" role="menu">
              <div className="topbar-menu-id">
                <div className="topbar-menu-name">{user.displayName}</div>
                <div className="topbar-menu-email">{user.email}</div>
              </div>
              <button className="topbar-menu-item" role="menuitem" onClick={signOut}>
                <LogOut size={14} />
                <span>Sign out</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}
